import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import HashLoader  from "react-spinners/HashLoader";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // ✅ Gunakan useCallback untuk menghindari re-render loop
  const fetchUser = useCallback(async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_BASE_URL}/usersweb/me`, {
        method: "GET",
      headers: {
          'Content-Type': 'application/json',
          'Authorization': "Bearer " + localStorage.getItem("token")
        },
       
      });const data = await res.json();
      console.log("gggg",data)

      if (!res.ok) {
        throw new Error("Tidak bisa mengambil data user");
      }

      
      
      setUser(data.data);
    } catch (err) {
      console.error("Fetch user error:", err.message);
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  // ✅ Jalankan sekali saat mount
  useEffect(() => {
    fetchUser();
  }, [fetchUser]);

  const login = async (username, password, semester) => {
    try {
      const res = await fetch(`${process.env.REACT_APP_BASE_URL}/users/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ phonenumber: username, password, semester }),
      });

      const result = await res.json();

      if (!res.ok) throw new Error(result.message || "Login gagal");

      setUser(result.user);
      navigate("/"); // redirect ke home
    } catch (err) {
      console.error("Login error:", err.message);
      throw err;
    }
  };

  const logout = async () => {
    try {
      localStorage.removeItem('token');
      const res = await fetch(`${process.env.REACT_APP_BASE_URL}/users/logout`, {
        method: "POST",
        credentials: "include",
      });

      if (!res.ok) throw new Error("Logout gagal");

      setUser(null);
      navigate("/login");
    } catch (err) {
      console.error("Logout error:", err.message);
    }
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
    
      {!loading ? children :  <div className="loading" ><HashLoader size={50} /></div>}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
